export default "__VITE_ASSET__D_lQXEB5__"